import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sobre from "./paginas/funcionario/Sobre";
import Login from "./paginas/Login";
import Livros from "./paginas/funcionario/Livros";
import Emprestimo from "./paginas/funcionario/Emprestimo";
import Dashboard from "./paginas/funcionario/Dashboard";
import Alunos from "./paginas/funcionario/Alunos";
import TelaInicial from "./paginas/aluno/TelaInicial";
import Ranking from "./paginas/aluno/Ranking";
import PerfilAluno from "./paginas/aluno/PerfilAluno";
import MinhaBibliotecaAluno from "./paginas/aluno/MinhaBibliotecaAluno";
import ChatIA from "./paginas/aluno/ChatIA";
import DashboardAluno from "./paginas/aluno/DashboardAluno";
import SobreAluno from "./paginas/aluno/SobreAluno";
import { RotaPrivada } from "./rota/RotaPrivada";
import TelasNavegacao from "./cabecalho/TelasNavegacao";
import VisualizacaoAlunos from "./paginas/funcionario/VisualizacaoAlunos";
import VisualizacaoLivros from "./paginas/funcionario/VisualizacaoLivros";
import { ToastContainer } from "react-toastify";
import { CriarSenha } from "./paginas/CriarSenha";

function App() {
  const admFunc = ["ADMIN", "FUNCIONARIO"]
  const aluno = ["ALUNO"]
  
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route path="/login" element={<Login />} />
        
        <Route path="/livros" element={ <RotaPrivada roles={admFunc}> <TelasNavegacao> <Livros /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/emprestimo" element={ <RotaPrivada roles={admFunc}> <TelasNavegacao> <Emprestimo /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/dashboard" element={ <RotaPrivada roles={admFunc}> <TelasNavegacao> <Dashboard /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/alunos" element={ <RotaPrivada roles={admFunc}> <TelasNavegacao> <Alunos /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/visualizacaoAlunos/:id" element={ <RotaPrivada roles={admFunc}> <TelasNavegacao> <VisualizacaoAlunos /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/visualizacaoLivros/:id" element={ <RotaPrivada roles={admFunc}> <TelasNavegacao> <VisualizacaoLivros /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/sobre" element={ <RotaPrivada roles={admFunc}> <TelasNavegacao> <Sobre /> </TelasNavegacao> </RotaPrivada>}/>

        {/* rotas telas alunos */}
        <Route path="/telaInicial" element={ <RotaPrivada roles={aluno}> <TelasNavegacao> <TelaInicial /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/ranking" element={ <RotaPrivada roles={aluno}> <TelasNavegacao> <Ranking /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/perfilAluno" element={ <RotaPrivada roles={aluno}> <TelasNavegacao> <PerfilAluno /> </TelasNavegacao> </RotaPrivada>}/>
        <Route path="/minhaBibliotecaAluno" element={ <RotaPrivada roles={aluno}> <TelasNavegacao> <MinhaBibliotecaAluno /> </TelasNavegacao> </RotaPrivada>}/>
        <Route path="/chatIA" element={ <RotaPrivada roles={aluno}> <TelasNavegacao> <ChatIA /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/dashboardAluno" element={ <RotaPrivada roles={aluno}> <TelasNavegacao> <DashboardAluno /> </TelasNavegacao> </RotaPrivada>}/>
        <Route path="/sobreAluno" element={ <RotaPrivada roles={aluno}> <TelasNavegacao> <SobreAluno /> </TelasNavegacao> </RotaPrivada> }/>
        <Route path="/criarSenha/:hash" element={<CriarSenha />} />
      </Routes>
    </Router>
  );
}

export default App;
